export default {
  header: {
    title: "Cloud Services",
    subtitle: "Connect your cloud accounts to import and manage your resources"
  },
  infoBanner: {
    title: "Secure connection",
    description: "Your credentials are securely stored and never shared. Use credentials with minimal necessary permissions."
  },
  providers: {
    azure: "Microsoft Azure",
    aws: "Amazon Web Services",
    gcp: "Google Cloud Platform"
  },
  status: {
    connected: "Connected",
    notConnected: "Not connected"
  },
  details: {
    lastSync: "Last sync:",
    resources: "Resources:",
    never: "Never"
  },
  actions: {
    test: "Test",
    configure: "Configure",
    connect: "Connect"
  },
  disconnect: {
    confirm: "Are you sure you want to disconnect this cloud service?"
  },
  testConnection: {
    alert: "Testing connection {{provider}}..."
  },
  modal: {
    title: "Configure {{provider}}",
    subtitle: "Enter your credentials to connect your cloud account",
    cancel: "Cancel",
    save: "Save",
    security: {
      title: "Security",
      description: "Make sure to use credentials with minimal necessary permissions. Never share your access keys."
    },
    azure: {
      tenantId: "Tenant ID",
      clientId: "Client ID (Application ID)",
      clientSecret: "Client Secret",
      subscriptionId: "Subscription ID",
      tenantIdPlaceholder: "00000000-0000-0000-0000-000000000000"
    },
    aws: {
      accessKeyId: "Access Key ID",
      secretAccessKey: "Secret Access Key",
      region: "Default region",
      regions: {
        usEast1: "US East (N. Virginia)",
        usWest2: "US West (Oregon)",
        euWest1: "EU (Ireland)",
        euCentral1: "EU (Frankfurt)",
        apSoutheast1: "Asia Pacific (Singapore)"
      }
    },
    gcp: {
      projectId: "Project ID",
      serviceAccountKey: "Service Account Key (JSON)",
      serviceAccountKeyPlaceholder: '{"type": "service_account", ...}'
    }
  }
};
